module.exports = __webpack_public_path__ + "img/move-icon.0718f4e3.svg";